import { render, staticRenderFns } from "./MotivationScoring.vue?vue&type=template&id=84c081a6&scoped=true&"
import script from "./MotivationScoring.vue?vue&type=script&lang=js&"
export * from "./MotivationScoring.vue?vue&type=script&lang=js&"
import style0 from "./MotivationScoring.vue?vue&type=style&index=0&id=84c081a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c081a6",
  null
  
)

export default component.exports